import { useLocalSearchParams } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import ClaimNpoForm from '@/components/forms/ClaimNpoForm';

const ClaimNpo = () => {
  const { npoName, nonProfitOrgId } = useLocalSearchParams<{ npoName: string; nonProfitOrgId: string }>();

  return (
    <SafeAreaView style={styles.flexOne} edges={['bottom']}>
      <View style={styles.container}>
        <ClaimNpoForm npoName={npoName} nonProfitOrgId={nonProfitOrgId} />
      </View>
    </SafeAreaView>
  );
};

export default ClaimNpo;

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  container: {
    flex: 1,
    paddingHorizontal: 18
  }
});
